import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class AdmissionApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
